import React from 'react';

const DeleteModule = ({ name }) => {
    return (
        <div>
            <p>Please confirm if you wish to delete this <span style={{color: "red"}}>module({name})</span>.</p>
        </div>
    )
}
export default DeleteModule;